export default __webpack_public_path__ + "static/media/walletcard.1c29cb02.svg";